/* eslint-disable import/no-named-default */
import { default as MasterJobTitle } from "./Jobtitle";

export default MasterJobTitle;
